// /src/components/auth/Login.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import ForgotPasswordModal from './ForgotPasswordModal';
import './Login.css';

const Login = ({ onBackToHome }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error: authError } = await signIn(email, password);

      if (authError) {
        setError(authError);
        setLoading(false);
        return;
      }

      // Verificar que el usuario tenga rol de admin
      const userRole = data?.user?.user_metadata?.role;
      if (userRole !== 'admin') {
        setError('No tienes permisos de administrador.');
        setLoading(false);
        return;
      }

      navigate('/admin');
    } catch (err) {
      setError('Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {onBackToHome && (
          <button type="button" onClick={onBackToHome} className="login-back" aria-label="Volver atrás">
            <ArrowLeft size={20} />
          </button>
        )}

        <div className="login-header">
          <img src="/letracopagimnasta.png" alt="CopaGimnasta" className="login-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
          <h2>Panel Administrador</h2>
          <p>Ingresa tus credenciales</p>
        </div>

        {error && (
          <div className="login-alert-error">
            <AlertCircle size={18} />
            <span>{error}</span>
          </div>
        )}
        
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label>Correo Electrónico</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@copagimnasta.com"
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              required
              disabled={loading}
            />
          </div>
          
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <button
          type="button"
          onClick={() => setShowForgot(true)}
          style={{ display: 'block', margin: '12px auto 0', background: 'none', border: 'none', color: '#6b7280', fontSize: '0.82rem', cursor: 'pointer', textDecoration: 'underline' }}
        >
          ¿Olvidaste tu contraseña?
        </button>
        
        <p style={{ textAlign: 'center', fontSize: '0.68rem', color: '#94a3b8', marginTop: '20px', letterSpacing: '0.02em' }}>
          © {new Date().getFullYear()} CopaGimnasta. Todos los derechos reservados.
        </p>
      </div>
      <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />
    </div>
  );
};

export default Login;